"use strict";

exports.__esModule = true;
exports.c_background_image_BackgroundImage_sm_2x = {
  "name": "--pf-c-background-image--BackgroundImage--sm-2x",
  "value": "url(\"../../assets/images/pfbg_768@2x.jpg\")",
  "var": "var(--pf-c-background-image--BackgroundImage--sm-2x)"
};
exports["default"] = exports.c_background_image_BackgroundImage_sm_2x;